angular.module('ui.order.orderItemCard.orderReports', [])

    .directive('orderReports', function () {
        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'app/ui/order/orderItemCard/orderReports/orderReports.html',
            controller: 'OrderReportsController'
        };
    })

    .controller('OrderReportsController', function ($scope, $state, $q, $log, toastr, rest, orderItemCardDataProvider, reportManager, $timeout,
                                                    orderItemsGridSharedSettings) {

        var oiGridSharedSettings = orderItemsGridSharedSettings;

        orderItemCardDataProvider.onDataChange('OrderReportsController', function () {
            initData();
        });

        $scope.$on("$destroy", function () {
            orderItemCardDataProvider.onDataChange('OrderReportsController', void 0);
        });

        function initData() {
            var singleOrderReportsListName = "order-reports";
            $scope.step = $state.params.step ? $state.params.step : 'all-open';
            $scope.pageSize = 15;
            $scope.reports = null;
            $scope.orderItem = orderItemCardDataProvider.getOrderItem();
            if (!$scope.orderItem) {
                return;
            }
            $scope.orderItemId = $scope.orderItem.getId();
            if (!$scope.orderItemId) {
                return;
            }

            //Get reports list and render report links
            reportManager.getReportListByName(oiGridSharedSettings.getStepFilter(), singleOrderReportsListName, $scope.orderItem)
                .then(function (results) {
                    var reports = [];
                    _.forEach(results, function (value) {
                        reports.push({
                            "name": value.name,
                            "value": value
                        });
                    });

                    $scope.reports = reports;

                }, function (error) {
                    $log.error(_.string.sprintf("Can't initialize report list [%s]: ", singleOrderReportsListName));
                    if (error && error.message) {
                        $log.error(error.message);
                    } else if (error && _.isString(error)) {
                        $log.error(error);
                    } else {
                        $log.error("Unknown error");
                    }
                });
        }


        $scope.showReport = function (reportName) {

            var report = _.find($scope.reports, function (r) {
                return r.name == reportName;
            }); //get the clicked report configuration

            if (report && !!report.value.requiresSelection && angular.isDefined($scope.orderItemId)) {
                //we use the selected item id as a query for the report
                reportManager.show({
                    report: report.value,
                    query: [$scope.orderItemId],
                    orderBy: report.value.orderBy,
                    backAction: function () {
                        $state.go('client.step', {step: $scope.step});
                    }
                });
            }
            //do nothing if report requires selection and we don't have an item id
        }
    })

;
